import { SocietyEquityMarketStatus } from 'types/Society';
import { EquityMarketAdminPanelContextType } from '../types/EquityMarketAdminPanelContextType';
import { tabs } from './Tabs';

export const equityMarketAdminPanelInitValue: EquityMarketAdminPanelContextType =
  {
    data: {
      societyId: '',
      societyName: '',
      equityMarketStatus: SocietyEquityMarketStatus.OPEN,
      sellOffers: [],
      buyOffers: [],
      sellOffersCount: 0,
      buyOffersCount: 0,
      selectedTab: tabs.SELL,
      statusCounts: {
        BUY: {
          DRAFT: 0,
          PENDING: 0,
          ACTIVE: 0,
          ACCEPTED: 0,
          REJECTED: 0,
          EXPIRED: 0,
          CANCELED: 0,
        },
        SELL: {
          DRAFT: 0,
          PENDING: 0,
          ACTIVE: 0,
          ACCEPTED: 0,
          REJECTED: 0,
          EXPIRED: 0,
          CANCELED: 0,
        },
      },
      activeSellOffers: [],
      activeBuyOffers: [],
      operations: [],
      sellOffersSummary: { offersCount: 0, sharesCount: 0, totalAmount: 0 },
      buyOffersSummary: { offersCount: 0, sharesCount: 0, totalAmount: 0 },
      pendingOperationsCount: 0,
      partners: [],
      isAdmin: false,
      isLoading: true,
    },
    actions: {
      handleGoBack: () => {},
      handleChangeOffersPage: () => {},
      handleChangeOffersRowsPerPage: () => {},
      handleChangeTab: () => {},
      handleEquityMarketStatusChange: () => {},
      handleViewOfferDetail: () => {},
      handleViewOperationDetail: () => {},
      handleUpdateOperationStatus: () => {},
      handleTogglePartnerEquityMarketAccess: () => {},
    },
  };
